/* 24 Nights theme: gallery, bundles, variants, AJAX cart drawer, sticky add to cart, shipping dates. */
(function () {
  'use strict';

  var T = window.theme || { routes: {} };
  var routes = T.routes || {};

  /* ---------- money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var f = format || T.moneyFormat || '${{amount}}';
    var re = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(n, dec, thou, decSep) {
      dec = isNaN(dec) ? 2 : dec; thou = thou || ','; decSep = decSep || '.';
      if (isNaN(n) || n == null) return '0';
      var parts = (n / 100).toFixed(dec).split('.');
      return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thou) + (parts[1] ? decSep + parts[1] : '');
    }
    var m = f.match(re);
    if (!m) return f;
    var v;
    switch (m[1]) {
      case 'amount_no_decimals': v = fmt(cents, 0); break;
      case 'amount_with_comma_separator': v = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = fmt(cents, 2, "'", '.'); break;
      default: v = fmt(cents, 2);
    }
    return f.replace(re, v);
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function sized(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  var ICON = {
    plus: '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>',
    minus: '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M5 12h14"/></svg>'
  };

  /* ---------- cart drawer ---------- */
  var drawer = document.querySelector('[data-cart-drawer]');
  var lastFocus = null;

  function openDrawer() {
    if (!drawer) { window.location.href = routes.cart_url; return; }
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('no-scroll');
    var close = drawer.querySelector('[data-cart-close].icon-button');
    if (close) close.focus();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('no-scroll');
    if (lastFocus) lastFocus.focus();
  }
  function getCart() {
    return fetch(routes.cart_url + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function changeLine(key, qty) {
    return fetch(routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }
  function renderCart(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
    if (!drawer) return;
    var list = drawer.querySelector('[data-cart-items]');
    var empty = drawer.querySelector('[data-cart-empty]');
    var foot = drawer.querySelector('[data-cart-footer]');
    var sub = drawer.querySelector('[data-cart-subtotal]');
    var disc = drawer.querySelector('[data-cart-discounts]');
    empty.hidden = cart.item_count > 0;
    foot.hidden = cart.item_count === 0;
    list.innerHTML = cart.items.map(function (item) {
      var discounts = (item.line_level_discount_allocations || []).map(function (d) {
        return '<span class="cart-line__disc">' + esc(d.discount_application.title) + ' (-' + formatMoney(d.amount) + ')</span>';
      }).join('');
      var variant = item.product_has_only_default_variant ? '' : '<span class="cart-line__variant">' + esc(item.variant_title) + '</span>';
      var was = item.original_line_price > item.final_line_price ? '<s>' + formatMoney(item.original_line_price) + '</s>' : '';
      return '<li class="cart-line">' +
        (item.image ? '<img class="cart-line__img" src="' + esc(sized(item.image, 200)) + '" alt="" width="72" height="72">' : '<span></span>') +
        '<div class="cart-line__info">' +
          '<a class="cart-line__title" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' + variant + discounts +
          '<div class="qty"><button type="button" data-line-qty="' + esc(item.key) + '" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease quantity">' + ICON.minus + '</button>' +
          '<span>' + item.quantity + '</span>' +
          '<button type="button" data-line-qty="' + esc(item.key) + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase quantity">' + ICON.plus + '</button></div>' +
          '<button type="button" class="cart-line__remove" data-line-qty="' + esc(item.key) + '" data-qty="0">Remove</button>' +
        '</div>' +
        '<span class="cart-line__price">' + was + formatMoney(item.final_line_price) + '</span>' +
      '</li>';
    }).join('');
    var cartDisc = (cart.cart_level_discount_applications || []).map(function (d) {
      return '<p><span>' + esc(d.title) + '</span><span>-' + formatMoney(d.total_allocated_amount) + '</span></p>';
    }).join('');
    disc.innerHTML = cartDisc;
    sub.textContent = formatMoney(cart.total_price);
  }

  if (drawer) {
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-close]')) { closeDrawer(); return; }
      var q = e.target.closest('[data-line-qty]');
      if (q) {
        q.disabled = true;
        changeLine(q.getAttribute('data-line-qty'), parseInt(q.getAttribute('data-qty'), 10));
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer(); });
  }
  document.querySelectorAll('[data-cart-open]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      if (!drawer || T.cartType === 'page') return;
      e.preventDefault();
      getCart().then(renderCart).then(openDrawer);
    });
  });

  /* ---------- product forms ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (T.cartType === 'page' || !window.fetch || !window.FormData) return;
      e.preventDefault();
      var btn = form.querySelector('[data-add-button]');
      if (btn) btn.classList.add('is-loading');
      fetch(routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      })
        .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
        .then(getCart)
        .then(function (cart) { renderCart(cart); openDrawer(); })
        .catch(function (err) { window.alert((err && (err.description || err.message)) || 'Sorry, this could not be added to the cart.'); })
        .then(function () { if (btn) btn.classList.remove('is-loading'); });
    });
  });

  /* buttons elsewhere on the product page that should add the main product */
  document.querySelectorAll('[data-atc-proxy]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      var form = document.querySelector('[data-product-form]');
      if (!form) return;
      e.preventDefault();
      if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true }));
    });
  });

  /* ---------- product section: gallery, bundles, variants, sticky ---------- */
  document.querySelectorAll('[data-product-section]').forEach(function (section) {
    var track = section.querySelector('[data-gallery-track]');
    var slides = track ? Array.prototype.slice.call(track.querySelectorAll('[data-gallery-slide]')) : [];
    var thumbs = Array.prototype.slice.call(section.querySelectorAll('[data-gallery-thumb]'));
    var dots = Array.prototype.slice.call(section.querySelectorAll('[data-gallery-dot]'));

    function goTo(i, smooth) {
      if (!track || !slides[i]) return;
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
    }
    function mark(i) {
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); mark(i); }); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { goTo(i); mark(i); }); });
    if (track) {
      var raf;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
          mark(Math.min(i, slides.length - 1));
        });
      }, { passive: true });
    }

    var variantsEl = section.querySelector('[data-variants]');
    var variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
    var select = section.querySelector('[data-variant-select]');
    var priceEl = section.querySelector('[data-price]');
    var compareEl = section.querySelector('[data-compare]');
    var saveEl = section.querySelector('[data-save]');
    var addBtn = section.querySelector('[data-add-button]');
    var stickyPrice = section.querySelector('[data-sticky-price]');
    var current = variants.filter(function (v) { return select ? String(v.id) === select.value : true; })[0] || variants[0];

    function updateBundles(v) {
      section.querySelectorAll('[data-bundle]').forEach(function (b) {
        var q = parseInt(b.getAttribute('data-qty'), 10) || 1;
        var d = parseInt(b.getAttribute('data-discount'), 10) || 0;
        var full = v.price * q;
        var fin = Math.floor(full * (100 - d) / 100);
        var p = b.querySelector('[data-bundle-price]');
        var s = b.querySelector('[data-bundle-compare]');
        if (p) p.textContent = formatMoney(fin);
        if (s) { s.textContent = formatMoney(full); s.hidden = d <= 0; }
      });
    }
    function updateVariant(v) {
      if (!v) return;
      current = v;
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      if (compareEl) { compareEl.textContent = onSale ? formatMoney(v.compare_at_price) : ''; compareEl.hidden = !onSale; }
      if (saveEl) {
        saveEl.hidden = !onSale;
        if (onSale) saveEl.textContent = saveEl.getAttribute('data-template').replace('[percent]', Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price));
      }
      if (stickyPrice) stickyPrice.textContent = formatMoney(v.price);
      if (addBtn) {
        addBtn.disabled = !v.available;
        var label = addBtn.querySelector('[data-add-label]');
        if (label) label.textContent = v.available ? addBtn.getAttribute('data-label') : addBtn.getAttribute('data-soldout');
      }
      updateBundles(v);
      if (v.featured_media) {
        var idx = slides.findIndex(function (s) { return String(s.getAttribute('data-media-id')) === String(v.featured_media.id); });
        if (idx > -1) { goTo(idx); mark(idx); }
      }
    }
    if (select) select.addEventListener('change', function () {
      updateVariant(variants.filter(function (v) { return String(v.id) === select.value; })[0]);
    });

    var sticky = section.querySelector('[data-sticky-atc]');
    if (sticky && addBtn) {
      sticky.hidden = false;
      var ticking = false;
      var syncSticky = function () {
        ticking = false;
        sticky.classList.toggle('is-visible', addBtn.getBoundingClientRect().bottom < 0);
      };
      window.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; requestAnimationFrame(syncSticky); }
      }, { passive: true });
      syncSticky();
      var stickyBtn = sticky.querySelector('[data-sticky-submit]');
      if (stickyBtn) stickyBtn.addEventListener('click', function () {
        var form = section.querySelector('[data-product-form]');
        if (form.requestSubmit) form.requestSubmit(); else form.submit();
      });
    }
  });

  /* ---------- estimated shipping dates (business days) ---------- */
  document.querySelectorAll('[data-ship]').forEach(function (el) {
    function addBusinessDays(d, n) {
      var date = new Date(d.getTime());
      while (n > 0) {
        date.setDate(date.getDate() + 1);
        var wd = date.getDay();
        if (wd !== 0 && wd !== 6) n--;
      }
      return date;
    }
    var min = parseInt(el.getAttribute('data-min'), 10) || 0;
    var max = parseInt(el.getAttribute('data-max'), 10) || 0;
    var opts = { weekday: 'short', month: 'short', day: 'numeric' };
    var now = new Date();
    var start = addBusinessDays(now, min).toLocaleDateString('en-US', opts);
    var end = addBusinessDays(now, max).toLocaleDateString('en-US', opts);
    var text = el.querySelector('[data-ship-text]');
    if (text) text.innerHTML = text.getAttribute('data-template')
      .replace('[start_date]', '<strong>' + start + '</strong>')
      .replace('[end_date]', '<strong>' + end + '</strong>');
  });
})();
